/* EYESHELLS mobile menu controller, v1469.
   Owns drawer state, stable overflow locking, focus containment and nested accordions.
   The historical fixed-body/negative-top lock remains removed. Drawer visibility is
   now controlled only by explicit user actions and breakpoint changes; transient
   animation geometry is never allowed to auto-close an otherwise valid opening. */
(function (w, d) {
  'use strict';
  if (w.__esMobileMenuV1447) {
    try { w.__esMobileMenuV1447.rehydrate({ preserveState:true }); } catch (_err) {}
    return;
  }
  if (w.__esMobileMenuV1415 && typeof w.__esMobileMenuV1415.close === 'function') {
    try { w.__esMobileMenuV1415.close(); } catch (_legacyErr) {}
  }

  var mq = w.matchMedia ? w.matchMedia('(max-width:1199.98px)') : { matches:true };
  var trigger = null;
  var dialog = null;
  var backdrop = null;
  var closeButton = null;
  var previousFocus = null;
  var scrollY = 0;
  var isOpen = false;
  var panelTimers = typeof WeakMap === 'function' ? new WeakMap() : null;
  var focusTimer = 0;
  var lastToggleAt = 0;

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || d).querySelectorAll(selector));
  }

  function clearPanelTimer(panel) {
    if (!panel) return;
    var id = panelTimers ? panelTimers.get(panel) : panel.__esTimer;
    if (id) w.clearTimeout(id);
    if (panelTimers) panelTimers.delete(panel);
    else panel.__esTimer = 0;
  }

  function setPanelTimer(panel, fn, delay) {
    clearPanelTimer(panel);
    var id = w.setTimeout(function () {
      clearPanelTimer(panel);
      fn();
    }, delay);
    if (panelTimers) panelTimers.set(panel, id);
    else panel.__esTimer = id;
  }

  function reducedMotion() {
    return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion:reduce)').matches);
  }

  function setExpanded(button, expanded) {
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var item = button.closest('.es-acc-item,.es-sub-acc-item');
    if (item) item.classList.toggle('is-open', expanded);
  }

  function openPanel(panel) {
    if (!panel) return;
    clearPanelTimer(panel);
    panel.hidden = false;
    if (reducedMotion()) {
      panel.style.height = 'auto';
      return;
    }
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = panel.scrollHeight + 'px';
    setPanelTimer(panel, function () { panel.style.height = 'auto'; }, 280);
  }

  function closePanel(panel) {
    if (!panel) return;
    clearPanelTimer(panel);
    if (reducedMotion()) {
      panel.hidden = true;
      panel.style.height = '';
      return;
    }
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.height = '0px';
    setPanelTimer(panel, function () {
      panel.hidden = true;
      panel.style.height = '';
    }, 280);
  }

  function closeAccordionItem(item) {
    if (!item) return;
    var button = item.querySelector(':scope > .es-acc-trigger,:scope > .es-sub-trigger');
    var panel = item.querySelector(':scope > .es-acc-panel,:scope > .es-sub-panel');
    if (button) setExpanded(button, false);
    closePanel(panel);
  }

  function resetAccordions() {
    if (!dialog) return;
    qsa(dialog, '.es-acc-item,.es-sub-acc-item').forEach(function (item) {
      var button = item.querySelector(':scope > .es-acc-trigger,:scope > .es-sub-trigger');
      var panel = item.querySelector(':scope > .es-acc-panel,:scope > .es-sub-panel');
      item.classList.remove('is-open','is-opening','is-closing');
      if (button) button.setAttribute('aria-expanded','false');
      if (panel) {
        clearPanelTimer(panel);
        panel.hidden = true;
        panel.style.height = '';
      }
    });
  }

  function clearLegacyFixedBodyStyles() {
    var body = d.body;
    if (!body) return;
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('left');
    body.style.removeProperty('right');
    body.style.removeProperty('width');
    body.style.removeProperty('padding-right');
  }

  function unlockPage(restoreScroll) {
    var body = d.body;
    var root = d.documentElement;
    if (!body || !root) return;
    var wasLegacyFixed = body.style.position === 'fixed';
    root.classList.remove('es-mobile-menu-open');
    body.classList.remove('activemenu_mobile');
    clearLegacyFixedBodyStyles();
    /* Normal overflow locking never changes the scroll position. Restore only
       when clearing a stale fixed-body state left by an older cached runtime. */
    if (restoreScroll && wasLegacyFixed) {
      try { w.scrollTo(0, scrollY); } catch (_err) {}
    }
  }

  function lockPage() {
    var body = d.body;
    var root = d.documentElement;
    if (!body || !root) return;
    scrollY = w.pageYOffset || root.scrollTop || 0;
    clearLegacyFixedBodyStyles();
    root.classList.add('es-mobile-menu-open');
    body.classList.add('activemenu_mobile');
  }

  function clearFocusTimer() {
    if (!focusTimer) return;
    w.clearTimeout(focusTimer);
    focusTimer = 0;
  }

  function focusables() {
    if (!dialog) return [];
    return qsa(dialog, 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])').filter(function (el) {
      return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null;
    });
  }

  function setOpen(open, options) {
    var next = !!open && mq.matches;
    if (!trigger || !dialog || !backdrop) return;
    if (next === isOpen && !(options && options.force)) return;
    var wasOpen = isOpen;
    isOpen = next;

    trigger.classList.toggle('active', next);
    trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
    trigger.setAttribute('aria-label', next ? 'Close menu' : 'Open menu');
    dialog.classList.toggle('active', next);
    dialog.setAttribute('aria-hidden', next ? 'false' : 'true');
    backdrop.classList.toggle('active', next);
    backdrop.setAttribute('aria-hidden', next ? 'false' : 'true');
    backdrop.tabIndex = next ? 0 : -1;

    if (next) {
      previousFocus = d.activeElement;
      lockPage();
      clearFocusTimer();
      focusTimer = w.setTimeout(function () {
        focusTimer = 0;
        if (!isOpen || !dialog || !dialog.classList.contains('active')) return;
        var target = closeButton || focusables()[0] || dialog;
        try { target.focus({ preventScroll:true }); } catch (_err) { try { target.focus(); } catch (_err2) {} }
      }, reducedMotion() ? 0 : 80);
    } else {
      clearFocusTimer();
      unlockPage(wasOpen && (!options || options.restoreScroll !== false));
      resetAccordions();
      if (!options || options.restoreFocus !== false) {
        var target2 = previousFocus && d.contains(previousFocus) ? previousFocus : trigger;
        w.setTimeout(function () {
          try { target2.focus({ preventScroll:true }); } catch (_err) { try { target2.focus(); } catch (_err2) {} }
        }, 0);
      }
      previousFocus = null;
    }
  }

  function onToggleCapture(event) {
    var toggle = event.target && event.target.closest ? event.target.closest('.js-mobile-menu-toggle') : null;
    if (!toggle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var now = Date.now();
    if (now - lastToggleAt < 280) return;
    lastToggleAt = now;
    try { toggle.focus({ preventScroll:true }); } catch (_err) { try { toggle.focus(); } catch (_err2) {} }
    setOpen(!isOpen);
  }

  function onClick(event) {
    if (event.target.closest('.js-eveland-close') || event.target === backdrop) {
      event.preventDefault();
      setOpen(false);
      return;
    }
    if (!dialog) return;

    var topButton = event.target.closest('.es-acc-trigger');
    if (topButton && dialog.contains(topButton)) {
      event.preventDefault();
      var item = topButton.closest('.es-acc-item');
      qsa(dialog, '.es-acc-item.is-open').forEach(function (other) { if (other !== item) closeAccordionItem(other); });
      var panel = item.querySelector(':scope > .es-acc-panel');
      var expanded = topButton.getAttribute('aria-expanded') === 'true';
      setExpanded(topButton, !expanded);
      if (expanded) closePanel(panel); else openPanel(panel);
      return;
    }

    var subButton = event.target.closest('.es-sub-trigger');
    if (subButton && dialog.contains(subButton)) {
      event.preventDefault();
      var subItem = subButton.closest('.es-sub-acc-item');
      var subPanel = subItem.querySelector(':scope > .es-sub-panel');
      var subExpanded = subButton.getAttribute('aria-expanded') === 'true';
      setExpanded(subButton, !subExpanded);
      if (subExpanded) closePanel(subPanel); else openPanel(subPanel);
      return;
    }

    var link = event.target.closest('a[href]');
    if (link && dialog.contains(link)) setOpen(false, { restoreFocus:false });
  }

  function onKeydown(event) {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && d.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && d.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function removeLegacyBindings() {
    if (!w.jQuery) return;
    try {
      w.jQuery('.js-mobile-menu-toggle').off('click.esMobileMenuToggle');
      w.jQuery('.logo_menumoblie a,.logo_menumoblie .logourl').off('click.esMobileMenuLogoNav');
      w.jQuery('.box_contentmenu_background').off('click.esMobileMenuBackdrop');
      w.jQuery('.js-eveland-close').off('click.esMobileMenuClose');
      w.jQuery('.box_contentmenu a').off('click.esMobileMenuLinkNav');
      w.jQuery(w).off('pageshow.esMobileMenuState pagehide.esMobileMenuState beforeunload.esMobileMenuState');
    } catch (_err) {}
  }

  function cacheNodes() {
    var previousTrigger = trigger;
    var previousDialog = dialog;
    var previousBackdrop = backdrop;
    trigger = d.querySelector('.js-mobile-menu-toggle');
    dialog = d.getElementById('esMobileMenuDialog') || d.querySelector('.box_contentmenu');
    backdrop = d.querySelector('.box_contentmenu_background');
    closeButton = dialog ? dialog.querySelector('.js-eveland-close') : null;
    return previousTrigger !== trigger || previousDialog !== dialog || previousBackdrop !== backdrop;
  }

  function syncVisualState() {
    if (!trigger || !dialog || !backdrop) return;
    trigger.classList.toggle('active', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    trigger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    dialog.classList.toggle('active', isOpen);
    dialog.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    backdrop.classList.toggle('active', isOpen);
    backdrop.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    backdrop.tabIndex = isOpen ? 0 : -1;
  }

  function rehydrate(options) {
    var preserveState = !!(options && options.preserveState);
    var wasOpen = isOpen;
    var oldNodesConnected = !!(trigger && trigger.isConnected && dialog && dialog.isConnected && backdrop && backdrop.isConnected);
    var nodesChanged = cacheNodes();
    removeLegacyBindings();

    if (!trigger || !dialog || !backdrop) {
      if (wasOpen) unlockPage(false);
      isOpen = false;
      return;
    }

    /* Unrelated Shopify section/app updates must not close an open menu. Only
       a genuine replacement of the header/menu nodes, a stale disconnected
       tree, or leaving the mobile breakpoint is allowed to reset state. */
    if (!mq.matches || (nodesChanged && !oldNodesConnected)) {
      if (wasOpen) unlockPage(false);
      isOpen = false;
      resetAccordions();
      syncVisualState();
      return;
    }

    if (!preserveState && nodesChanged) {
      if (wasOpen) unlockPage(false);
      isOpen = false;
      resetAccordions();
    } else {
      isOpen = wasOpen;
    }

    syncVisualState();
    if (isOpen) lockPage();
    else unlockPage(false);
  }

  function onBreakpoint() {
    if (!mq.matches) setOpen(false, { restoreFocus:false });
  }

  function boot() {
    cacheNodes();
    if (!trigger || !dialog || !backdrop) return;
    removeLegacyBindings();
    resetAccordions();
    d.addEventListener('click', onToggleCapture, true);
    d.addEventListener('click', onClick);
    d.addEventListener('keydown', onKeydown);
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
    w.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        setOpen(false, { restoreFocus:false, restoreScroll:false, force:true });
        return;
      }
      rehydrate({ preserveState:true });
    });
    w.addEventListener('pagehide', function () { setOpen(false, { restoreFocus:false, restoreScroll:false }); });

    function sectionTouchesMenu(event) {
      var target = event && event.target;
      if (!trigger || !trigger.isConnected || !dialog || !dialog.isConnected || !backdrop || !backdrop.isConnected) return true;
      if (!target || target === d) return false;
      if (target === trigger || target === dialog || target === backdrop) return true;
      if (target.contains && (target.contains(trigger) || target.contains(dialog) || target.contains(backdrop))) return true;
      if (target.querySelector && target.querySelector('.menu_moblie,#esMobileMenuDialog,.box_contentmenu_background')) return true;
      return false;
    }

    ['shopify:section:load','shopify:section:reorder','shopify:section:unload'].forEach(function (name) {
      d.addEventListener(name, function (event) {
        if (!sectionTouchesMenu(event)) return;
        w.setTimeout(function () { rehydrate({ preserveState:true }); }, 0);
      });
    });
    rehydrate({ preserveState:false });
  }

  w.__esMobileMenuV1447 = { open:function(){setOpen(true);}, close:function(){setOpen(false);}, rehydrate:rehydrate };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
})(window, document);
